import type { CSSProperties } from "react";
import { useState } from "react";
import type { Prototype } from "./prototypes";

const WorkspaceIcon = () => (
  <div
    style={{
      width: 32,
      height: 32,
      borderRadius: "var(--radius-xs)",
      border: "1px solid var(--color-border-primary)",
      background: "var(--color-bg-primary)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      flexShrink: 0,
      overflow: "hidden",
    }}
  >
    <svg width="17" height="20" viewBox="0 0 17 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.7239 0.564799L14.7649 2.77514C16.1477 3.53149 17 4.93245 17 6.44896V13.551C17 15.0675 16.1477 16.4685 14.7649 17.2249L10.7239 19.4352C9.34713 20.1883 7.65287 20.1883 6.2761 19.4352L2.23511 17.2249C0.852329 16.4685 0 15.0675 0 13.551V6.44896C0 4.93245 0.852329 3.53149 2.23511 2.77514L6.2761 0.564799C7.65287 -0.188266 9.34713 -0.188266 10.7239 0.564799ZM6.35687 4.42203L6.31495 4.44475L2.78922 6.37988C1.45079 7.1145 0.62115 8.46582 0.604692 9.93267L0.604442 9.97715V10.0228C0.604442 11.492 1.42069 12.8506 2.74882 13.5977L2.78922 13.6201L6.31495 15.5552C7.65311 16.2897 9.29864 16.2973 10.6431 15.578L10.6851 15.5552L14.2108 13.6201C15.5492 12.8855 16.3789 11.5342 16.3953 10.0673L16.3956 10.0228V9.97715C16.3956 8.50802 15.5793 7.14935 14.2512 6.40233L14.2108 6.37988L10.6851 4.44475C9.34689 3.71029 7.70136 3.70271 6.35687 4.42203Z" fill="#172B4D" />
    </svg>
  </div>
);

function DiamondIcon({ active }: { active: boolean }) {
  const style: CSSProperties = {
    width: 20,
    height: 20,
    flexShrink: 0,
    color: active ? "var(--color-content-brand)" : "var(--color-content-secondary)",
  };
  return active ? (
    <svg style={style} viewBox="0 0 20 20" fill="currentColor" stroke="currentColor" strokeWidth="0.75" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10.0005 1.88169C10.1148 1.88175 10.228 1.90417 10.3335 1.9481C10.4393 1.99223 10.5361 2.05707 10.6167 2.13853L10.6177 2.14048L12.8599 4.3827C13.0213 4.5476 13.1118 4.769 13.1118 4.9999C13.1118 5.2309 13.0215 5.453 12.8599 5.618L10.6167 7.8612C10.5361 7.9426 10.4393 8.0075 10.3335 8.0516C10.228 8.0956 10.1148 8.118 10.0005 8.118C9.886 8.118 9.7722 8.0957 9.6665 8.0516C9.5607 8.0075 9.4639 7.9426 9.3833 7.8612L7.1401 5.618C6.9785 5.453 6.8882 5.2309 6.8882 4.9999C6.8882 4.769 6.9788 4.5476 7.1401 4.3827L9.3823 2.14048L9.3833 2.13853C9.4639 2.05707 9.5607 1.99223 9.6665 1.9481C9.7722 1.90409 9.886 1.88169 10.0005 1.88169Z" />
      <path d="M5.0005 6.8817C5.1148 6.8818 5.228 6.9042 5.3335 6.9481C5.4393 6.9922 5.5361 7.0571 5.6167 7.1385L5.6177 7.1405L7.8599 9.3827C8.0213 9.5476 8.1118 9.769 8.1118 9.9999C8.1118 10.2309 8.0215 10.453 7.8599 10.618L5.6167 12.8612C5.5361 12.9426 5.4393 13.0075 5.3335 13.0516C5.228 13.0956 5.1148 13.118 5.0005 13.118C4.886 13.118 4.7722 13.0957 4.6665 13.0516C4.5607 13.0075 4.4639 12.9426 4.3833 12.8612L2.1401 10.618C1.9785 10.453 1.8882 10.2309 1.8882 9.9999C1.8882 9.769 1.9788 9.5476 2.1401 9.3827L4.3823 7.1405L4.3833 7.1385C4.4639 7.0571 4.5607 6.9922 4.6665 6.9481C4.7722 6.9041 4.886 6.8817 5.0005 6.8817Z" />
      <path d="M15.0005 6.8817C15.1148 6.8818 15.228 6.9042 15.3335 6.9481C15.4393 6.9922 15.5361 7.0571 15.6167 7.1385L15.6177 7.1405L17.8599 9.3827C18.0213 9.5476 18.1118 9.769 18.1118 9.9999C18.1118 10.2309 18.0215 10.453 17.8599 10.618L15.6167 12.8612C15.5361 12.9426 15.4393 13.0075 15.3335 13.0516C15.228 13.0956 15.1148 13.118 15.0005 13.118C14.886 13.118 14.7722 13.0957 14.6665 13.0516C14.5607 13.0075 14.4639 12.9426 14.3833 12.8612L12.1401 10.618C11.9785 10.453 11.8882 10.2309 11.8882 9.9999C11.8882 9.769 11.9788 9.5476 12.1401 9.3827L14.3823 7.1405L14.3833 7.1385C14.4639 7.0571 14.5607 6.9922 14.6665 6.9481C14.7722 6.9041 14.886 6.8817 15.0005 6.8817Z" />
      <path d="M10.0005 11.8817C10.1148 11.8818 10.228 11.9042 10.3335 11.9481C10.4393 11.9922 10.5361 12.0571 10.6167 12.1385L10.6177 12.1405L12.8599 14.3827C13.0213 14.5476 13.1118 14.769 13.1118 14.9999C13.1118 15.2309 13.0215 15.453 12.8599 15.618L10.6167 17.8612C10.5361 17.9426 10.4393 18.0075 10.3335 18.0516C10.228 18.0956 10.1148 18.118 10.0005 18.118C9.886 18.118 9.7722 18.0957 9.6665 18.0516C9.5607 18.0075 9.4639 17.9426 9.3833 17.8612L7.1401 15.618C6.9785 15.453 6.8882 15.2309 6.8882 14.9999C6.8882 14.769 6.9788 14.5476 7.1401 14.3827L9.3823 12.1405L9.3833 12.1385C9.4639 12.0571 9.5607 11.9922 9.6665 11.9481C9.7722 11.9041 9.886 11.8817 10.0005 11.8817Z" />
    </svg>
  ) : (
    <svg style={style} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M9.5554 2.31873L7.31255 4.56159C7.06847 4.80566 7.06847 5.20139 7.31255 5.44547L9.55374 7.68667C9.79782 7.93074 10.1935 7.93074 10.4376 7.68667L12.6805 5.44381C12.9246 5.19973 12.9246 4.80401 12.6805 4.55993L10.4393 2.31873C10.1952 2.07465 9.79948 2.07465 9.5554 2.31873Z" />
      <path d="M14.5559 7.31873L12.313 9.56159C12.069 9.80566 12.069 10.2014 12.313 10.4455L14.5542 12.6867C14.7983 12.9307 15.194 12.9307 15.4381 12.6867L17.681 10.4438C17.9251 10.1997 17.9251 9.80401 17.681 9.55993L15.4398 7.31873C15.1957 7.07466 14.8 7.07466 14.5559 7.31873Z" />
      <path d="M4.5554 7.31168L2.31255 9.55453C2.06847 9.79861 2.06847 10.1943 2.31255 10.4384L4.55374 12.6796C4.79782 12.9237 5.19355 12.9237 5.43763 12.6796L7.68048 10.4368C7.92456 10.1927 7.92456 9.79695 7.68048 9.55287L5.43928 7.31168C5.19521 7.0676 4.79948 7.0676 4.5554 7.31168Z" />
      <path d="M9.55589 12.3117L7.31304 14.5545C7.06896 14.7986 7.06896 15.1943 7.31304 15.4384L9.55424 17.6796C9.79831 17.9237 10.194 17.9237 10.4381 17.6796L12.681 15.4368C12.9251 15.1927 12.9251 14.797 12.681 14.5529L10.4398 12.3117C10.1957 12.0676 9.79997 12.0676 9.55589 12.3117Z" />
    </svg>
  );
}

function HomeNavItem({
  label,
  active,
  onClick,
}: {
  label: string;
  active: boolean;
  onClick?: () => void;
}) {
  const [hovered, setHovered] = useState(false);
  const interactive = Boolean(onClick);

  const containerStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "var(--spacing-s)",
    height: 32,
    padding: "var(--spacing-xs) var(--spacing-s)",
    borderRadius: "var(--radius-s)",
    width: "100%",
    cursor: interactive ? "pointer" : "default",
    background: active
      ? "var(--color-bg-brand-lightest)"
      : hovered && interactive
      ? "rgba(23,43,77,0.04)"
      : "transparent",
    transition: "background 120ms ease",
    userSelect: "none",
  };

  const labelStyle: CSSProperties = {
    flex: "1 0 0",
    minWidth: 0,
    fontFamily: "var(--font-family-base)",
    fontSize: 14,
    fontWeight: active ? 700 : 500,
    lineHeight: "20px",
    letterSpacing: active ? "-0.28px" : 0,
    color: active ? "var(--color-content-brand)" : "var(--color-content-secondary)",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  };

  return (
    <div
      style={containerStyle}
      onClick={onClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onClick?.()}
    >
      <DiamondIcon active={active} />
      <span style={labelStyle}>{label}</span>
    </div>
  );
}

function SectionLabel({ children }: { children: string }) {
  return (
    <div
      style={{
        padding: "var(--spacing-xs) var(--spacing-s)",
        fontFamily: "var(--font-family-base)",
        fontSize: 13,
        fontWeight: 500,
        color: "var(--color-content-secondary)",
      }}
    >
      {children}
    </div>
  );
}

interface HomeSidebarProps {
  fieldServicePrototypes: Prototype[];
  cmmsPrototypes: Prototype[];
  onOpenFieldService: () => void;
  onOpenCmms: () => void;
}

export function HomeSidebar({
  fieldServicePrototypes,
  cmmsPrototypes,
  onOpenFieldService,
  onOpenCmms,
}: HomeSidebarProps) {
  const sidebarStyle: CSSProperties = {
    width: 224,
    height: "100vh",
    background: "var(--color-bg-accent)",
    display: "flex",
    flexDirection: "column",
    flexShrink: 0,
    position: "sticky",
    top: 0,
    overflow: "hidden",
  };

  const headerStyle: CSSProperties = {
    padding: "var(--spacing-m) var(--spacing-l)",
    borderBottom: "1px solid var(--color-border-primary)",
    borderRight: "1px solid var(--color-border-primary)",
    display: "flex",
    flexDirection: "column",
    gap: "var(--spacing-l)",
    flexShrink: 0,
  };

  const middleStyle: CSSProperties = {
    flex: "1 0 0",
    padding: "var(--spacing-l)",
    borderRight: "1px solid var(--color-border-primary)",
    overflowY: "auto",
    overflowX: "hidden",
    display: "flex",
    flexDirection: "column",
    gap: "var(--spacing-xs)",
    minHeight: 0,
  };

  function handlePrototypeClick(prototype: Prototype, onOpenInternal: () => void) {
    if (prototype.kind === "internal") onOpenInternal();
  }

  return (
    <aside style={sidebarStyle}>
      <div style={headerStyle}>
        <div style={{ display: "flex", alignItems: "center", gap: "var(--spacing-s)" }}>
          <WorkspaceIcon />
          <span
            style={{
              flex: 1,
              fontFamily: "var(--font-family-base)",
              fontSize: 14,
              fontWeight: 700,
              lineHeight: "20px",
              letterSpacing: "-0.28px",
              color: "var(--color-content-primary)",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            }}
          >
            Makula Technologies
          </span>
        </div>
      </div>

      <div style={middleStyle}>
        <HomeNavItem label="Dashboard" active />

        <SectionLabel>Field Service</SectionLabel>
        {fieldServicePrototypes.map((prototype) =>
          prototype.kind === "external" ? (
            <a
              key={prototype.label}
              href={prototype.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <HomeNavItem label={prototype.label} active={false} onClick={() => {}} />
            </a>
          ) : (
            <HomeNavItem
              key={prototype.label}
              label={prototype.label}
              active={false}
              onClick={
                prototype.kind === "placeholder"
                  ? undefined
                  : () => handlePrototypeClick(prototype, onOpenFieldService)
              }
            />
          )
        )}

        <SectionLabel>CMMS</SectionLabel>
        {cmmsPrototypes.map((prototype) =>
          prototype.kind === "external" ? (
            <a
              key={prototype.label}
              href={prototype.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none" }}
            >
              <HomeNavItem label={prototype.label} active={false} onClick={() => {}} />
            </a>
          ) : (
            <HomeNavItem
              key={prototype.label}
              label={prototype.label}
              active={false}
              onClick={
                prototype.kind === "placeholder"
                  ? undefined
                  : () => handlePrototypeClick(prototype, onOpenCmms)
              }
            />
          )
        )}
      </div>
    </aside>
  );
}
